import * as type from "../types/single-list";

const initialState = {
  firstLoad: true,
  list: [],
  responses: [],
  notes: [],
  deletions: [],
  displayIndex: 0,
  fetchFullList: {
    error: null,
    loading: true,
  },
  fetchListResponses: {
    error: null,
    loading: true,
  },
  removeSingleCompany: {
    status: null,
    loading: false,
    error: null,
    companyId: null,
  },
  addSingleResponse: {
    status: null,
    loading: false,
    error: null,
  },
  removeClient: {
    status: null,
    loading: false,
    error: null,
  },
  addClient: {
    status: null,
    loading: false,
    error: null,
  },
  addSingleNote: {
    status: null,
    loading: false,
    error: null,
  },
  removeSingleNote: {
    status: null,
    loading: false,
    error: null,
  },
  fetchSingleDetails: {
    status: null,
    loading: true,
    error: null,
  },
  fetchSingleNotes: {
    status: null,
    loading: true,
    error: null,
  },
  fetchClientCheck: {
    status: null,
    loading: true,
    error: null,
  },
  fetchListDeletions: {
    status: null,
    loading: null,
    error: null,
  },
  addOpportunity: {
    status: null,
    loading: false,
    error: null,
  },
  addContact: {
    status: null,
    loading: false,
    error: null,
  },
  fetchContactLists: {
    data: [],
    status: null,
    error: null,
    loading: false,
  },
  activeDisplay: {
    general: {
      name: null,
      organizationNumber: null,
      industry: null,
      employees: null,
      parentCompany: {
        id: null,
        infoUrl: null,
        name: null,
        organizationNumber: null,
      },
      established: null,
      shareCapital: null,
      roles: [],
      shareholders: [],
    },
    financials: {
      creditRating: {
        date: null,
        description: null,
        rating: null,
      },
    },
    address: {
      street: null,
      postalCode: null,
      city: null,
      coordinates: null,
      county: null,
      municipality: null,
      region: null,
    },
    contact: {
      phone: null,
      email: null,
      website: null,
    },
    social: {
      twitter: null,
      facebook: null,
    },
  },
  showModals: {
    addOpportunityModal: false,
    addContactModal: false,
  },
};

export const singleList = (state = initialState, payload) => {
  switch (payload.type) {
    case type.SET_SINGLE_LIST_DISPLAY_INDEX:
      return {
        ...state,
        displayIndex: payload.index,
      };
    case type.REQUEST_SINGLE_LIST_DETAILS:
      return {
        ...state,
        list: [],
        fetchFullList: {
          ...state.fetchFullList,
          error: null,
          loading: true,
        },
      };
    case type.SET_SINGLE_LIST_DETAILS:
      return {
        ...state,
        list: payload.list,
        fetchFullList: {
          ...state.fetchFullList,
          error: null,
          loading: false,
        },
      };
    case type.REVOKE_SINGLE_LIST_DETAILS:
      return {
        ...state,
        list: [],
        fetchFullList: {
          ...state.fetchFullList,
          error: payload.message,
          loading: false,
        },
      };
    case type.RESET_SINGLE_LIST_DETAILS:
      return {
        ...state,
        list: [],
        fetchFullList: {
          ...state.fetchFullList,
          error: null,
          loading: true,
        },
      };
    case type.REQUEST_SINGLE_LIST_RESPONSES:
      return {
        ...state,
        responses: [],
        fetchListResponses: {
          ...state.fetchListResponses,
          error: null,
          loading: true,
        },
      };
    case type.SET_SINGLE_LIST_RESPONSES:
      return {
        ...state,
        responses: payload.responses,
        fetchListResponses: {
          ...state.fetchListResponses,
          error: null,
          loading: false,
        },
      };
    case type.REVOKE_SINGLE_LIST_RESPONSE:
      return {
        ...state,
        responses: [],
        fetchListResponses: {
          ...state.fetchListResponses,
          error: payload.message,
          loading: false,
        },
      };
    case type.RESET_SINGLE_LIST_RESPONSE:
      return {
        ...state,
        responses: [],
        fetchListResponses: {
          ...state.fetchListResponses,
          error: null,
          loading: false,
        },
      };
    case type.REQUEST_SET_ACTIVE_COMPANY_DETAILS:
      return {
        ...state,
        activeDisplay: {
          general: {
            name: null,
            organizationNumber: null,
            industry: null,
            employees: null,
            parentCompany: {
              id: null,
              infoUrl: null,
              name: null,
              organizationNumber: null,
            },
            established: null,
            shareCapital: null,
            roles: [],
            shareholders: [],
          },
          financials: {
            creditRating: {
              date: null,
              description: null,
              rating: null,
            },
          },
          address: {
            street: null,
            postalCode: null,
            city: null,
            coordinates: null,
            county: null,
            municipality: null,
            region: null,
          },
          contact: {
            phone: null,
            email: null,
            website: null,
          },
          social: {
            twitter: null,
            facebook: null,
          },
        },
        fetchSingleDetails: {
          ...state.fetchSingleDetails,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_SET_ACTIVE_COMPANY_DETAILS:
      return {
        ...state,
        activeDisplay: payload.details,
        fetchSingleDetails: {
          ...state.fetchSingleDetails,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_SET_ACTIVE_COMPANY_DETAILS:
      return {
        ...state,
        activeDisplay: {
          general: {
            name: null,
            organizationNumber: null,
            industry: null,
            employees: null,
            parentCompany: {
              id: null,
              infoUrl: null,
              name: null,
              organizationNumber: null,
            },
            established: null,
            shareCapital: null,
            roles: [],
            shareholders: [],
          },
          financials: {
            creditRating: {
              date: null,
              description: null,
              rating: null,
            },
          },
          address: {
            street: null,
            postalCode: null,
            city: null,
            coordinates: null,
            county: null,
            municipality: null,
            region: null,
          },
          contact: {
            phone: null,
            email: null,
            website: null,
          },
          social: {
            twitter: null,
            facebook: null,
          },
        },
        fetchSingleDetails: {
          ...state.fetchSingleDetails,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_SET_ACTIVE_COMPANY_DETAILS:
      return {
        ...state,
        activeDisplay: {
          general: {
            name: null,
            organizationNumber: null,
            industry: null,
            employees: null,
            parentCompany: {
              id: null,
              infoUrl: null,
              name: null,
              organizationNumber: null,
            },
            established: null,
            shareCapital: null,
            roles: [],
            shareholders: [],
          },
          financials: {
            creditRating: {
              date: null,
              description: null,
              rating: null,
            },
          },
          address: {
            street: null,
            postalCode: null,
            city: null,
            coordinates: null,
            county: null,
            municipality: null,
            region: null,
          },
          contact: {
            phone: null,
            email: null,
            website: null,
          },
          social: {
            twitter: null,
            facebook: null,
          },
        },
        fetchSingleDetails: {
          ...state.fetchSingleDetails,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REQUEST_SET_ACTIVE_COMPANY_NOTES:
      return {
        ...state,
        notes: [],
        fetchSingleNotes: {
          ...state.fetchSingleNotes,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_SET_ACTIVE_COMPANY_NOTES:
      return {
        ...state,
        notes: payload.notes,
        fetchSingleNotes: {
          ...state.fetchSingleNotes,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_SET_ACTIVE_COMPANY_NOTES:
      return {
        ...state,
        notes: [],
        fetchSingleNotes: {
          ...state.fetchSingleNotes,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_SET_ACTIVE_COMPANY_NOTES:
      return {
        ...state,
        notes: [],
        fetchSingleNotes: {
          ...state.fetchSingleNotes,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_REMOVE_LIST_COMPANY_NOTE:
      return {
        ...state,
        removeSingleNote: {
          ...state.removeSingleNote,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_REMOVE_LIST_COMPANY_NOTE:
      return {
        ...state,
        removeSingleNote: {
          ...state.removeSingleNote,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_REMOVE_LIST_COMPANY_NOTE:
      return {
        ...state,
        removeSingleNote: {
          ...state.removeSingleNote,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_REMOVE_LIST_COMPANY_NOTE:
      return {
        ...state,
        removeSingleNote: {
          ...state.removeSingleNote,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_ADD_LIST_COMPANY_NOTE:
      return {
        ...state,
        addSingleNote: {
          ...state.addSingleNote,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_ADD_LIST_COMPANY_NOTE:
      return {
        ...state,
        addSingleNote: {
          ...state.addSingleNote,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_ADD_LIST_COMPANY_NOTE:
      return {
        ...state,
        addSingleNote: {
          ...state.addSingleNote,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_ADD_LIST_COMPANY_NOTE:
      return {
        ...state,
        addSingleNote: {
          ...state.addSingleNote,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_LIST_COMPANY_STATUS:
      return {
        ...state,
        fetchClientCheck: {
          ...state.fetchClientCheck,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.SET_LIST_COMPANY_STATUS:
      return {
        ...state,
        fetchClientCheck: {
          ...state.fetchClientCheck,
          status: payload.status,
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_LIST_COMPANY_STATUS:
      return {
        ...state,
        fetchClientCheck: {
          ...state.fetchClientCheck,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_LIST_COMPANY_STATUS:
      return {
        ...state,
        fetchClientCheck: {
          ...state.fetchClientCheck,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REQUEST_CREATE_NEW_CLIENT:
      return {
        ...state,
        addClient: {
          ...state.addClient,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_CREATE_NEW_CLIENT:
      return {
        ...state,
        addClient: {
          ...state.addClient,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_CREATE_NEW_CLIENT:
      return {
        ...state,
        addClient: {
          ...state.addClient,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_CREATE_NEW_CLIENT:
      return {
        ...state,
        addClient: {
          ...state.addClient,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_REMOVE_EXISTING_CLIENT:
      return {
        ...state,
        removeClient: {
          ...state.removeClient,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_REMOVE_EXISTING_CLIENT:
      return {
        ...state,
        removeClient: {
          ...state.removeClient,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_REMOVE_EXISTING_CLIENT:
      return {
        ...state,
        removeClient: {
          ...state.removeClient,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_REMOVE_EXISTING_CLIENT:
      return {
        ...state,
        removeClient: {
          ...state.removeClient,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_ADD_LIST_COMPANY_RESPONSE:
      return {
        ...state,
        addSingleResponse: {
          ...state.addSingleResponse,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_ADD_LIST_COMPANY_RESPONSE:
      return {
        ...state,
        addSingleResponse: {
          ...state.addSingleResponse,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_ADD_LIST_COMPANY_RESPONSE:
      return {
        ...state,
        addSingleResponse: {
          ...state.addSingleResponse,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_ADD_LIST_COMPANY_RESPONSE:
      return {
        ...state,
        addSingleResponse: {
          ...state.addSingleResponse,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_COMPANY_DELETIONS:
      return {
        ...state,
        deletions: [],
        fetchListDeletions: {
          ...state.fetchListDeletions,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.SET_COMPANY_DELETIONS:
      return {
        ...state,
        deletions: payload.list,
        fetchListDeletions: {
          ...state.fetchListDeletions,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_COMPANY_DELETIONS:
      return {
        ...state,
        deletions: [],
        fetchListDeletions: {
          ...state.fetchListDeletions,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.RESET_COMPANY_DELETIONS:
      return {
        ...state,
        deletions: [],
        fetchListDeletions: {
          ...state.fetchListDeletions,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REQUEST_REMOVE_COMPANY_LISTING:
      return {
        ...state,
        removeSingleCompany: {
          ...state.removeSingleCompany,
          status: null,
          loading: true,
          error: null,
          companyId: payload.details.organizationNumber,
        },
      };
    case type.GRANT_REMOVE_COMPANY_LISTING:
      return {
        ...state,
        removeSingleCompany: {
          ...state.removeSingleCompany,
          status: payload.organizationNumber,
          loading: false,
          error: null,
          companyId: null,
        },
      };
    case type.REVOKE_REMOVE_COMPANY_LISTING:
      return {
        ...state,
        removeSingleCompany: {
          ...state.removeSingleCompany,
          status: null,
          loading: false,
          error: payload.message,
          companyId: null,
        },
      };
    case type.RESET_REMOVE_COMPANY_LISTING:
      return {
        ...state,
        removeSingleCompany: {
          ...state.removeSingleCompany,
          status: null,
          loading: false,
          error: null,
          companyId: null,
        },
      };
    case type.CHANGE_SINGLE_LIST_MODALS:
      if (
        payload.modal.addOpportunityModal === true ||
        payload.modal.addOpportunityModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            addOpportunityModal: payload.modal.addOpportunityModal,
          },
        };
      } else if (
        payload.modal.addContactModal === true ||
        payload.modal.addContactModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            addContactModal: payload.modal.addContactModal,
          },
        };
      } else {
        return state;
      }
    case type.REQUEST_CREATE_NEW_OPPORTUNITY:
      return {
        ...state,
        addOpportunity: {
          ...state.addOpportunity,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_CREATE_NEW_OPPORTUNITY:
      return {
        ...state,
        addOpportunity: {
          ...state.addOpportunity,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_CREATE_NEW_OPPORTUNITY:
      return {
        ...state,
        addOpportunity: {
          ...state.addOpportunity,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_CREATE_NEW_OPPORTUNITY:
      return {
        ...state,
        addOpportunity: {
          ...state.addOpportunity,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_FETCH_CONTACT_LISTS:
      return {
        ...state,
        fetchContactLists: {
          ...state.fetchContactLists,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_FETCH_CONTACT_LISTS:
      return {
        ...state,
        fetchContactLists: {
          ...state.fetchContactLists,
          data: payload.data,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_FETCH_CONTACT_LISTS:
      return {
        ...state,
        fetchContactLists: {
          ...state.fetchContactLists,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_FETCH_CONTACT_LISTS:
      return {
        ...state,
        fetchContactLists: {
          ...state.fetchContactLists,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_CREATE_NEW_CONTACT:
      return {
        ...state,
        addContact: {
          ...state.addContact,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_CREATE_NEW_CONTACT:
      return {
        ...state,
        addContact: {
          ...state.addContact,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_CREATE_NEW_CONTACT:
      return {
        ...state,
        addContact: {
          ...state.addContact,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_CREATE_NEW_CONTACT:
      return {
        ...state,
        addContact: {
          ...state.addContact,
          status: null,
          loading: false,
          error: null,
        },
      };
    default:
      return state;
  }
};
